import { useState } from "react";
import { Button, Container, Grid, TextField, Typography } from "@mui/material";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import CustomBreadcrumbs from "../../../../../components/breadcrumbs";
import SectionTitle from "../../../../../components/sectionTitle";
import ResponseComponent from "../../../../../components/responseComponent";
import QUDProgress from "../../../../../components/progress";
import { createAttributeValue } from "../../../../../controllers/company/products/AttributesValuesController";

export default function AttributesValuesCreate()
{
    const [value,setValue] = useState('');
    const [errorValue,setErrorValue] = useState(false);

    const [description,setDescription] = useState('');
    const [errorDescription,setErrorDescription] = useState(false);

    const [isLoading,setIsLoading] = useState(false);

    const [open,setOpen] = useState(false);
    const [title,setTitle] = useState('');
    const [message,setMessage] = useState('');
    const [success,setSuccess] = useState(false);

    const history = useHistory();
    const { attributeId, attributeName } = useParams();
    

    const formVerification = () => {
        let ban = 0;

        if(value === '')
        {
            setErrorValue(true);
            ban = 1;
        }

        if(description === '')
        {
            setErrorDescription(true);
            ban = 1;
        }

        return ban;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if(formVerification()===0)
        {
            setIsLoading(true);
            const response = await createAttributeValue(attributeId,value,description);
            if(response.success === true)
            {
                setTitle('Operación Exitosa');
                setMessage(response.message);
                setSuccess(true);
                setOpen(true);
            }
            else
            {
                setTitle('Operación Fallida');
                setMessage(response.message);
                setSuccess(false);
                setOpen(true);
            }

            setIsLoading(false);
        }
    }

    const handleClose = () => {
        setOpen(false);
        if(success === true)
        {
            history.push('/products/attributes/values/'+attributeId);
        }
    }

    return(
        <Container maxWidth='xl'>
            <CustomBreadcrumbs
                returnTo={'/products/attributes/values/'+attributeId}
                crumbs={[
                    {name:'Productos',link:'/products'},
                    {name:'Atributos',link:'/products/attributes'},
                    {name:attributeName,link:'/products/attributes/values/'+attributeId},
                    {name:'Crear',link:'/products/attributes/create'}
                ]}
            />
            <br/>
            <SectionTitle title={attributeName} subtitle={'(Crear valor de atributo)'} />

            <Grid container spacing={3} justifyContent={'center'}>
                <Grid item xs={12} md={8} lg={4} xl={4}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} lg={12} xl={12}>
                            <TextField
                                label='Valor'
                                fullWidth
                                value={value}
                                onChange={(e)=>setValue(e.target.value)}
                                onBlur={()=>setErrorValue(value==='')}
                                error={errorValue}
                                helperText={errorValue?<Typography>El valor es obligatorio</Typography>:''}
                            />
                            <Typography style={{fontSize: 16, color: 'gray', marginTop: 4}}>
                                Es el nombre de la opción individual que el cliente seleccionará (Ejemplos: "Pequeño", "Rojo", "16GB", "Algodón").
                            </Typography>
                        </Grid>

                        <Grid item xs={12} lg={12} xl={12}>
                            <TextField
                                label='Descripción'
                                fullWidth
                                value={description}
                                onChange={(e)=>setDescription(e.target.value)}
                                onBlur={()=>setErrorDescription(value==='')}
                                error={errorDescription}
                                helperText={errorDescription?<Typography>La descripción es obligatorio</Typography>:''}
                            />
                            
                        </Grid>

                        <Grid item lg={12} xl={12}>
                            <Button
                                fullWidth
                                variant="contained"
                                sx={{mt:2}}
                                onClick={(e)=>handleSubmit(e)}
                            >
                                <Typography>Crear Valor de Atributo</Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <QUDProgress open={isLoading}/>
            <ResponseComponent
                show={open}
                success={success}
                title={title}
                message={message}
                actionText={'Finalizar'}
                onClick={()=>handleClose()}
            />
        </Container>
    )
}